export default defineNuxtPlugin(() => {
  const MIN = 13
  const MAX = 90
  const setRem = () => {
    const w = window.innerWidth
    const size = Math.max(MIN, Math.min(MAX, w / 19.2))
    document.documentElement.style.fontSize = `${size}px`
  }
  if (process.client) {
    setRem()
    window.addEventListener('resize', setRem)
    window.addEventListener('orientationchange', setRem)
  }
})